import { DateRange, Option } from '@types';
import {
  DateFormat,
  formatISODate,
  getStartAndEndDateOfLastMonth,
  getStartAndPresentDateOfCurrentMonth
} from '@utils/date';

export enum LeadDateRangeOptionEnum {
  THIS_MONTH = 'this-month',
  LAST_MONTH = 'last-month',
  CUSTOM = 'custom'
}

const renderDateRangeOption = (
  label: string,
  dateRange: DateRange,
  format: DateFormat = 'MMMM YYYY'
) => {
  const formattedYearDateRange = `${formatISODate({
    date: dateRange.startDate,
    format: 'YYYY'
  })}-${formatISODate({
    date: dateRange.endDate,
    format: 'YYYY'
  })}`;

  return (
    <div className="flex justify-between text-base">
      <div className="text-darkGrey">{label}</div>
      <div className="text-grey">
        {format === 'MMMM YYYY' &&
          formatISODate({
            date: dateRange.startDate,
            format
          })}
        {format === 'YYYY' && formattedYearDateRange}
      </div>
    </div>
  );
};

export const leadDateRangeOptions: Option[] = [
  {
    key: LeadDateRangeOptionEnum.THIS_MONTH,
    value: 'Current Month',
    element: renderDateRangeOption(
      'Current Month',
      getStartAndPresentDateOfCurrentMonth(),
      'MMMM YYYY'
    )
  },
  {
    key: LeadDateRangeOptionEnum.LAST_MONTH,
    value: 'Last Month',
    element: renderDateRangeOption(
      'Last Month',
      getStartAndEndDateOfLastMonth(),
      'MMMM YYYY'
    )
  }
];
